import * as model from './models';

import axios from 'axios';

/** 用户信息接口  代理商登出 */
export async function logoutUsingGET() {
  const headers: Record<string, string> = Object.create(null);

  const result = await axios.request<any>({
    url: `/rest/ad/inavad/account/agent/logout`,
    method: 'get',
  });
  return result.data;
}

/** 用户信息接口  用户同意协议 */
export async function agreeUsingPOST() {
  const headers: Record<string, string> = Object.create(null);
  headers['Content-Type'] = 'application/json';

  const result = await axios.request<model.IMessageVoid>({
    url: `/rest/ad/inavad/account/agree`,
    method: 'post',
    headers,
  });
  return result.data;
}

/** 用户信息接口  获取用户基本信息 */
export async function infoUsingPOST() {
  const headers: Record<string, string> = Object.create(null);
  headers['Content-Type'] = 'application/json';

  const result = await axios.request<model.IMessageAccountInfoView>({
    url: `/rest/ad/inavad/account/info`,
    method: 'post',
    headers,
  });
  return result.data;
}
